import React from "react";
import {
    CheckCircleOutlined, CloseCircleOutlined, DeliveredProcedureOutlined,
    DollarCircleOutlined, FileDoneOutlined, FileProtectOutlined,
    HourglassOutlined, ShoppingCartOutlined, SyncOutlined
} from "@ant-design/icons";
import { LOGGED_USER } from "../../../variables/constants";

export const getInitiator = (actions) =>
    actions?.filter(action => action.action === 'INITIER' || action.action === 'VALIDER')[0]?.acteur;

export const isConnectedUser = (actions) =>
    LOGGED_USER?.email === getInitiator(actions)?.email;

export const isConnectedUserFromPOOL = () =>
    LOGGED_USER?.profil?.organisme?.typeOrganisme === 'POOL';

export const getCodeHabilitation = (statutCommande) => {
    const map = {
        INITIE: "HCO071", VALIDE: "HCO072", AUTORISE: "HCO073",
        EN_TRAITEMENT: "HCO074", APPROUVE: "HCO075", REGLE: "HCO076"
    };
    return map[statutCommande];
};

export const getActionVerb = (statutCommande) => {
    switch (statutCommande) {
        case "INITIE": return "valider";
        case "VALIDE": return "autoriser";
        case "AUTORISE": return "receptionner et mettre en traitement";
        case "EN_TRAITEMENT": return "approuver";
        case "APPROUVE": return "régler";
        case "REGLE": return "livrer";
        case "DELIVRE": return "réceptionner";
        default: return null;
    }
};

export const getAntdIcon = (status) => {
    const statusIconMap = {
        INITIE: <ShoppingCartOutlined />,
        VALIDE: <CheckCircleOutlined />,
        AUTORISE: <SyncOutlined />,
        EN_TRAITEMENT: <HourglassOutlined />,
        APPROUVE: <FileProtectOutlined />,
        REGLE: <DollarCircleOutlined />,
        DELIVRE: <DeliveredProcedureOutlined />,
        RECEPTIONNE: <FileDoneOutlined />,
        REJETE: <CloseCircleOutlined />,
    };
    return statusIconMap[status] || null;
};

export const getAction = (actions, actionTypes) =>
    actions?.filter(action => actionTypes.includes(action.action)) || [];
